@if (data.show) {
  <div id="anchor_verified_reviews">
    <div class="w-full">
      <nscf-title
        [selector]="data.isFirstTitle ? 'h1' : 'h2'"
        class="text-center"
        [title]="data.title"
        [isCentered]="true"
        [id]="'anchor_verified_reviews_title'"
      >
      </nscf-title>
    </div>
  </div>
}
